import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '../redux/slices/profileSlice';
import LogoutDialog from './dialog/profileDialog/LogoutDialog';
import EditProfileDialog from './dialog/profileDialog/EditProfileDialog';
import BirthdayDialog from './dialog/profileDialog/BirthdayDialog';
import MobileNumberDialog from './dialog/profileDialog/MobileNumber';
import BankDetailsDialog from './dialog/profileDialog/BankDetailsDialog';
import DeleteBankAccount from './dialog/profileDialog/DeleteBankAccount';
import WithdrawDialog from './dialog/profileDialog/WithdrawDialog';
import AddBankAccountDialog from './dialog/profileDialog/AddBankAccountDialog';
import ResetPasswordDialog from './dialog/profileDialog/ResetPasswordDialog';
import NewPasswordDialog from './dialog/profileDialog/NewPasswordDialog';
import BetHistoryDialog from './dialog/profileDialog/BetHistoryDialog';
import TransactionHistoryDialog from './dialog/profileDialog/TransactionHistoryDialog';
import HintResetPasswordDialog from './dialog/profileDialog/HintResetPasswordDialog';
import ChangePasswordDialog from './dialog/profileDialog/ChangePasswordDialog';
import DailyCheckin from './DailyCheckin';
import Vip from '../views/referral/Vip';
import PendingDialog from './dialog/profileDialog/PendingDialog';
import TransactionDetails from './dialog/profileDialog/TransactionDetails';

const ProfileDialogContainer = () => {
  const dispatch = useDispatch();
  const { open, view, data } = useSelector((state) => state.profile);

  if (!open) return null;

  const handleClose = () => dispatch(closeModal());

  switch (view) {
    case 'pending-dialog':
      return <PendingDialog open={open} onClose={handleClose} />;

    case 'vip':
      return <Vip handleOpen={open} handleClose={handleClose} />;

    case 'transaction-details':
      return <TransactionDetails open={open} onClose={handleClose} data={data} />;

    case 'transaction-history':
      return <TransactionHistoryDialog handleOpen={open} handleClose={handleClose} />;

    case 'bet-history':
      return <BetHistoryDialog handleOpen={open} handleClose={handleClose} />;

    case 'hint-reset':
      return <HintResetPasswordDialog handleOpen={open} handleClose={handleClose} />;

    case 'change-password':
      return <ChangePasswordDialog handleOpen={open} handleClose={handleClose} />;

    case 'new-password':
      return <NewPasswordDialog handleOpen={open} handleClose={handleClose} />;

    case 'reset-password':
      return <ResetPasswordDialog handleOpen={open} handleClose={handleClose} />;

    case 'add-bank-account':
      return <AddBankAccountDialog handleOpen={open} handleClose={handleClose} />;

    case 'withdraw':
      return <WithdrawDialog handleOpen={open} handleClose={handleClose} />;

    case 'delete-bank-account':
      return <DeleteBankAccount handleOpen={open} handleClose={handleClose} />;

    case 'bank-details':
      return <BankDetailsDialog handleOpen={open} handleClose={handleClose} />;

    case 'mobile-number':
      return <MobileNumberDialog handleOpen={open} handleClose={handleClose} />;

    case 'birthday':
      return <BirthdayDialog handleOpen={open} handleClose={handleClose} />;

    case 'edit-profile':
      return <EditProfileDialog handleOpen={open} handleClose={handleClose} />;

    case 'daily-checkin':
      return <DailyCheckin open={open} onClose={handleClose} />;

    case 'logout':
      return <LogoutDialog handleOpen={open} handleClose={handleClose} />;
    default:
      return null;
  }
};

export default ProfileDialogContainer;
